var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-export",attrs:{"id":_vm.idName},on:{"click":_vm.generate}},[_c('div',{staticClass:"load",class:{anim:_vm.isLoading}}),_c('img',{attrs:{"src":require("../../assets/export.svg"),"alt":""}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }